import { useContext } from 'react';

import { Trans, useLingui } from '@lingui/react/macro';
import { Textarea } from '@repo/videa-components/src/ui/textarea';
import classNames from 'classnames';
import { useAtom, useAtomValue } from 'jotai';

import { previewModeAtom } from '@/modules/annotator/multiFileViewer/imageToolbar/atoms';

import { patientDownloadableNotesAtom } from '../../atoms';

import { ThemeModeContext } from './QRPrintDownloadContent';

interface PreviewSidebarNotesProps {
  setDisableKeyPress: (value: boolean) => void;
}

export const PreviewSidebarNotes = ({
  setDisableKeyPress,
}: PreviewSidebarNotesProps) => {
  const previewMode = useAtomValue(previewModeAtom);
  const [notes, setNotes] = useAtom(patientDownloadableNotesAtom);
  const { t } = useLingui();
  const mode = useContext(ThemeModeContext);
  return (
    <div>
      <div
        className={classNames(
          'vai-my-2',
          'vai-px-4 vai-py-2',
          'vai-bg-background-muted',
          'vai-flex vai-items-center vai-justify-left',
          {
            'vai-bg-background-muted vai-rounded-xs': mode === 'dark',
            'vai-bg-zinc-100 vai-rounded-sm': mode === 'light',
          },
        )}
      >
        <span
          className={classNames(
            'vai-text-sm vai-font-medium',
            'vai-block',
            'vai-text-center vai-items-center',
            'vai-font-inter',
            {
              'vai-text-foreground-dark': mode === 'dark',
              'vai-text-zinc-900': mode === 'light',
            },
          )}
        >
          <Trans>Note</Trans>
        </span>
      </div>
      <Textarea
        data-testid="notes-textarea"
        placeholder={t`Add notes here`}
        className={classNames(
          'vai-w-full',
          'vai-min-h-[150px]',
          'vai-bg-transparent',
          'vai-font-inter',
          {
            'vai-border-sidebar-border vai-text-foreground-dark':
              mode === 'dark',
            'vai-border-zinc-200 vai-text-zinc-900': mode === 'light',
          },
        )}
        onChange={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setNotes(e.target.value);
        }}
        value={notes}
        onClick={() => setDisableKeyPress(true)}
        onFocus={() => setDisableKeyPress(true)}
        onBlur={() => setDisableKeyPress(false)}
      />
      {notes && previewMode === 'qrCode' && (
        <div className="vai-mt-2">
          <span
            className={classNames(
              'vai-text-sm vai-font-inter vai-text-center',
              {
                'vai-text-foreground-dark': mode === 'dark',
                'vai-text-zinc-900': mode === 'light',
              },
            )}
          >
            <Trans>
              Your notes may contain sensitive details. Clicking “Generate QR”
              will create an access code for the patient to use when they open
              the page.
            </Trans>
          </span>
        </div>
      )}
    </div>
  );
};
